const initialState = {
  eventDetails: {},
  smpId: null,
  mongoId: null,
  dashboard: {},
  attendeesList: [],
  attendeesTableData: {
    'page_no': 1,
    'page_size': 10,
    'total_pages': 1,
    'total_elements': 10,
    'is_last': true,
    'is_first': true,
  },
  priceBreakups: {},
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'EVENT_DASHBOARD:EVENT_DATA:SET':
    return {
      ...state,
      eventDetails: data?.details,
      smpId: data?.smpId,
      mongoId: data?.mongoId || state?.mongoId,
    };
  case 'EVENT_DASHBOARD:DASHBOARD_DATA:SET':
    return {
      ...state,
      dashboard: data,
    };
  case 'EVENT_DASHBOARD:ATTENDEES_LIST:SET':
    return {
      ...state,
      attendeesList: data.attendeesList,
      attendeesTableData: data.pagination,
    };
  case 'EVENT_DASHBOARD:PRICE_BREAKUP:SET':
    return {
      ...state,
      priceBreakups: { ...state.priceBreakups, [action.price]: data },
    };
  default:
    return state;
  }
}